import {
  GET_SHIP_NODES,
} from 'constants/shipNodes';

export default (state = [], action) => {
    switch (action.type) {
    case `${GET_SHIP_NODES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
